export default __webpack_public_path__ + "assets/images/40e95954.png";